import { createSelector } from 'reselect';

const readings = state => state.readings.models;
const equipmentId = (_, equipmentId) => equipmentId;

const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

export const readingsByEquipmentId = createSelector(
    readings,
    equipmentId,
    (readings, equipmentId) => Object
        .values(readings)
        .filter(reading => reading.equipment_id === equipmentId)
        .sort((a, b) => collator.compare(a.name, b.name))
);

export const selectReadingsForDevice = device => createSelector(
    [readings],
    models =>
        Object.values(models).filter(reading => reading.equipment_id === device.equipment_id)
);

// What is not here has no system value to come.
export const selectReadingKindNamesForDevice = device => createSelector(
    [selectReadingsForDevice(device)],
    deviceReadings => deviceReadings.map(reading => reading.reading_kind_name)
);

export const selectReadingsByDeviceIdMap = device => createSelector(
    [selectReadingsForDevice(device)],
    deviceReadings => {
        const map = {};
        deviceReadings.forEach(reading => {
            map[reading.id] = reading;
        });
        return map;
    }
);

export default {
    selectReadingsForDevice,
    readingsByEquipmentId
};
